// extracted by mini-css-extract-plugin
export var navbarSubLink = "F_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "F_tM d_f0 d_dB";
export var subPageLink = "F_gf d_gf";
export var burger = "F_t9";
export var sublinkSize = "F_vb";
export var linkSize = "F_vc";
export var Link = "F_rd q_rd q_qr q_qM";